export const MAZE_GOAL_SOURCE_HANDLES = {
  true: 'true',
  false: 'false',
} as const;
